import { useRef } from 'react';

import cn from 'classnames';

import { ContentLayoutProvider } from './ContentLayout.context';

const CONTENT_LAYOUT_BREAKPOINT = 599;

export const ContentLayout = ({
  children,
  sideContent,
  side = 'right',
  className,
  ...rest
}: {
  children: React.ReactNode;
  sideContent?: React.ReactNode;
  side?: 'left' | 'right';
  className?: string;
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const sideElement = (
    <div
      id='content-layout-side'
      className='w-full shrink-0 @card:max-w-[min(272px,30%)] @card:min-w-[min(272px,30%)]'
    >
      {sideContent}
    </div>
  );

  return (
    <ContentLayoutProvider
      maxWidth={CONTENT_LAYOUT_BREAKPOINT}
      containerRef={containerRef}
    >
      <div
        {...rest}
        ref={containerRef}
        id='content-layout'
        className={cn(
          'rel min-h-0 @container mx-auto flex h-full w-full max-w-[1182px] flex-col gap-fly-5 pt-fly-4',
          className
        )}
      >
        <div
          className={cn(
            'flex h-full w-full gap-fly-5 @card:flex-row',
            side === 'left' ? 'flex-col' : 'flex-col-reverse'
          )}
        >
          {sideContent && side === 'left' && sideElement}
          <div
            id='content-layout-content'
            className='min-h-0 flex w-full min-w-auto grow flex-col @card:min-w-[312px]'
          >
            {children}
          </div>
          {sideContent && side === 'right' && sideElement}
        </div>
      </div>
    </ContentLayoutProvider>
  );
};
